"use client";

import { useMemo, useState } from "react";
import getVisibleProviders from "./helpers/getVisibleProviders";
import ProvidersGridList from "./ProvidersGridList";
import ProvidersToolbar from "./ProvidersToolbar";

type Props = {
  providers: ProviderTileData[];
  labels: ProvidersGridLabels;
  colorScheme: ColorScheme;
};

const ProvidersGrid: FC<Props> = ({ providers, labels, colorScheme }) => {
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState<ProvidersSortOption>("popular");

  const visibleProviders = useMemo(
    () => getVisibleProviders(providers, query, sort),
    [providers, query, sort],
  );

  return (
    <div className="flex flex-col gap-6">
      <ProvidersToolbar
        query={query}
        sort={sort}
        labels={labels}
        onQueryChange={setQuery}
        onSortChange={setSort}
      />
      <ProvidersGridList
        providers={visibleProviders}
        gamesCountOneTemplate={labels.gamesCountOne}
        gamesCountManyTemplate={labels.gamesCountMany}
        noResults={labels.noResults}
        colorScheme={colorScheme}
      />
    </div>
  );
};

export default ProvidersGrid;
